module.exports = __webpack_public_path__ + "static/media/success.00fc87b0.svg";